var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "show-hidden-list"
  }, [_c('div', {
    staticClass: "lh-21 show-hidden-list__list",
    class: [{
      'show-hidden-list__list_active': _vm.isActive
    }, ("show-hidden-list__list_" + (_vm.max))]
  }, [_vm._t("item")], 2), _vm._v(" "), _vm._t("default", function () {
    return [!_vm.isActive ? _c('div', {
      staticClass: "show-hidden-list__handler mt-6 fz-13",
      on: {
        "click": _vm.onClick
      }
    }, [_vm._v("\n      Показать все\n    ")]) : _vm._e()];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }